module.exports = __webpack_public_path__ + "static/popup-bbq-66c4a47d3b1dada1bd0355b0ca2ca390.png";